import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import GiftCardList from "./GiftCardList";

const GiftPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // URL query-с tab авах
  const params = new URLSearchParams(location.search);
  const activeKey = params.get("tab") || "1";

  return (
    <Tabs
      destroyInactiveTabPane
      activeKey={activeKey} // 🔥 ЭНЭ Л ЧУХАЛ
      items={[{ key: "1", label: "Харах", children: <GiftCardList /> }]}
      onChange={(key) => {
        navigate(`/GiftPage?tab=${key}`);
      }}
    />
  );
};

export default GiftPage;
